import { atom } from "recoil";

export const deferredPromptData = atom({
  key: "deferredPromptData",
  default: null,
});
